import React, { useState } from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const MenuItemCard = ({ item, onAddToCart }) => {
  const [showCustomization, setShowCustomization] = useState(false);
  const [customization, setCustomization] = useState('');
  const [quantity, setQuantity] = useState(1);

  const handleAddToCart = () => {
    onAddToCart({
      ...item,
      quantity,
      customization: customization?.trim() || null
    });
    setShowCustomization(false);
    setCustomization('');
    setQuantity(1);
  };

  return (
    <div className="bg-card rounded-xl shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden">
      <div className="relative h-48 md:h-56 lg:h-64 overflow-hidden">
        <Image
          src={item?.image}
          alt={item?.imageAlt}
          className="w-full h-full object-cover transition-transform duration-300 hover:scale-110"
        />
        {item?.isPopular && (
          <div className="absolute top-3 right-3 bg-primary text-primary-foreground px-3 py-1 rounded-full text-xs md:text-sm font-semibold flex items-center gap-1">
            <Icon name="TrendingUp" size={14} />
            Popular
          </div>
        )}
        {item?.isNew && (
          <div className="absolute top-3 left-3 bg-accent text-accent-foreground px-3 py-1 rounded-full text-xs md:text-sm font-semibold">
            New
          </div>
        )}
      </div>
      <div className="p-4 md:p-5 lg:p-6">
        <div className="flex items-start justify-between gap-2 mb-2 md:mb-3">
          <h3 className="text-base md:text-lg lg:text-xl font-bold text-foreground line-clamp-2 flex-1">{item?.name}</h3>
          <span className="text-lg md:text-xl lg:text-2xl font-bold text-primary whitespace-nowrap">
            SSP {item?.price?.toLocaleString()}
          </span>
        </div>

        <p className="text-sm md:text-base text-muted-foreground mb-3 md:mb-4 line-clamp-2">{item?.description}</p>

        <div className="flex flex-wrap gap-2 mb-3 md:mb-4">
          {item?.tags?.map((tag, index) => (
            <span
              key={index}
              className="px-2 py-1 bg-muted text-muted-foreground text-xs md:text-sm rounded-full"
            >
              {tag}
            </span>
          ))}
        </div>

        {!showCustomization ? (
          <div className="flex gap-2">
            <Button
              variant="outline"
              size="default"
              iconName="Settings"
              iconPosition="left"
              onClick={() => setShowCustomization(true)}
              className="flex-1"
            >
              Customize
            </Button>
            <Button
              variant="default"
              size="default"
              iconName="Plus"
              iconPosition="left"
              onClick={() => onAddToCart({ ...item, quantity: 1, customization: null })}
              className="flex-1"
            >
              Add to Cart
            </Button>
          </div>
        ) : (
          <div className="space-y-3 md:space-y-4">
            <Input
              type="text"
              label="Special Instructions"
              placeholder="e.g., Extra spicy, no onions"
              value={customization}
              onChange={(e) => setCustomization(e?.target?.value)}
              description="Optional customization for your order"
            />
            <div className="flex items-center gap-3">
              <span className="text-sm md:text-base text-muted-foreground">Quantity:</span>
              <div className="flex items-center gap-2 bg-muted rounded-lg p-1">
                <button
                  onClick={() => setQuantity(Math.max(1, quantity - 1))}
                  className="w-8 h-8 md:w-9 md:h-9 flex items-center justify-center hover:bg-background rounded transition-colors"
                  aria-label="Decrease quantity"
                >
                  <Icon name="Minus" size={16} />
                </button>
                <span className="text-base md:text-lg font-semibold w-8 md:w-10 text-center">{quantity}</span>
                <button
                  onClick={() => setQuantity(quantity + 1)}
                  className="w-8 h-8 md:w-9 md:h-9 flex items-center justify-center hover:bg-background rounded transition-colors"
                  aria-label="Increase quantity"
                >
                  <Icon name="Plus" size={16} />
                </button>
              </div>
            </div>
            <div className="flex gap-2">
              <Button
                variant="outline"
                size="default"
                onClick={() => {
                  setShowCustomization(false);
                  setCustomization('');
                  setQuantity(1);
                }}
                className="flex-1"
              >
                Cancel
              </Button>
              <Button
                variant="default"
                size="default"
                iconName="Check"
                iconPosition="left"
                onClick={handleAddToCart}
                className="flex-1"
              >
                Add to Cart
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MenuItemCard;